/**
 * Lazy load all images except:
 * - Images with fetchpriority="high" (LCP candidates)
 * - Images with 'no-lazy' class
 * 
 * Usage: <img src="..." class="no-lazy"> to disable lazy loading for specific images
 */
document.addEventListener('DOMContentLoaded', function() {
    // Get all images that don't have the no-lazy class AND aren't LCP candidates
    const images = document.querySelectorAll('img:not(.no-lazy)');
    
    images.forEach(img => {
        // Skip if it has fetchpriority="high" (LCP image, should not be lazy)
        if (img.getAttribute('fetchpriority') === 'high') {
            // Remove loading="lazy" if somehow present
            img.removeAttribute('loading');
            return;
        }
        
        // Skip if already has loading attribute set
        if (img.getAttribute('loading')) {
            return;
        }
        
        // Add lazy loading for non-priority images
        img.setAttribute('loading', 'lazy');
        
        // Add decoding for performance
        if (!img.getAttribute('decoding')) {
            img.setAttribute('decoding', 'async');
        }
    });
});
